<template>
	<div>
		<nav class="navbar has-background-black-ter py-3 mb-3" role="navigation" aria-label="main navigation">
			<div class="navbar-brand">
				<a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</a>
			</div>

			<div class="navbar-menu is-justify-content-space-between">
				<div class="container is-fluid">
					<div class="columns">
						<div class="column is-5 is-flex is-align-items-center">
							<RouterLink to="/" class="navbar-item">Official</RouterLink>
							<RouterLink to="/goodies" class="navbar-item">Goodies</RouterLink>
							<RouterLink to="/demos" class="navbar-item">Demos</RouterLink>
							<span class="nav-divider">|</span>
							<RouterLink to="/virtual-skipper" class="navbar-item">Virtual Skipper</RouterLink>
							<span class="nav-divider">|</span>
							<RouterLink to="/gallery" class="navbar-item">Gallery</RouterLink>
						</div>
						<div class="column is-2">
							<div class="content has-text-centered mb-0">
								<h1 class="pt-3 title is-size-4 mb-0">TM Collection</h1>
								<p class="is-italic is-size-7">by SUPERCOBY</p>
							</div>
						</div>
						<div class="column is-5 is-flex is-align-items-center is-justify-content-flex-end">
							<div class="control has-icons-left mr-3" v-if="$route.name === 'home'">
								<input class="input" type="text" placeholder="Search game" v-model="searchGame" id="search-game" />
								<span class="icon is-small is-left">
									<i class="fas fa-search"></i>
								</span>
							</div>
							<div class="control has-icons-left mr-3" v-if="$route.name === 'gallery'">
								<input class="input" type="text" placeholder="Search name" v-model="searchName" id="search-name" />
								<span class="icon is-small is-left">
									<i class="fas fa-search"></i>
								</span>
							</div>
							<div
								class="dropdown mr-3"
								:class="showFilterDropdown ? 'is-active' : ''"
								v-if="['home', 'goodies', 'demos', 'virtualskipper'].includes($route.name)"
							>
								<div class="dropdown-trigger" @click="showFilterDropdown = !showFilterDropdown">
									<button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
										<span>Filters</span>
										<span class="icon is-small">
											<i class="fas fa-angle-down" aria-hidden="true"></i>
										</span>
									</button>
								</div>
								<div class="dropdown-menu" id="dropdown-menu" role="menu">
									<div class="dropdown-content">
										<a class="dropdown-item" :class="ownFilter === true ? 'has-text-success' : ''" @click="ownFilter = true"
											>Owned</a
										>
										<a class="dropdown-item" :class="ownFilter === 'soon' ? 'has-text-success' : ''" @click="ownFilter = 'soon'"
											>On the way</a
										>
										<a class="dropdown-item" :class="ownFilter === false ? 'has-text-success' : ''" @click="ownFilter = false"
											>Not owned</a
										>
										<a
											class="dropdown-item"
											:class="ownFilter === undefined ? 'has-text-success' : ''"
											@click="ownFilter = undefined"
											>All</a
										>
										<template v-if="$route.name === 'home'">
											<hr class="dropdown-divider dropdown-item p-0" />
											<div class="dropdown-item is-size-7 pl-2 pb-1">Rarity</div>
											<a
												class="dropdown-item"
												:class="rarityFilter === 'Gem' ? 'has-text-success' : ''"
												@click="rarityFilter = 'Gem'"
												>Gem</a
											>
											<a
												class="dropdown-item"
												:class="rarityFilter === 'Very Rare' ? 'has-text-success' : ''"
												@click="rarityFilter = 'Very Rare'"
												>Very rare</a
											>
											<a
												class="dropdown-item"
												:class="rarityFilter === 'Rare' ? 'has-text-success' : ''"
												@click="rarityFilter = 'Rare'"
												>Rare</a
											>
											<a
												class="dropdown-item"
												:class="rarityFilter === 'Common' ? 'has-text-success' : ''"
												@click="rarityFilter = 'Common'"
												>Common</a
											>
											<a
												class="dropdown-item"
												:class="rarityFilter === 'All' ? 'has-text-success' : ''"
												@click="rarityFilter = 'All'"
												>All</a
											>
										</template>
									</div>
								</div>
							</div>
							<div id="socials" class="buttons is-justify-content-center">
								<a href="https://discord.gg/QhfB3UKSe5" class="button socials-button" target="_blank">
									<span class="icon is-small">
										<i class="fab fa-discord"></i>
									</span>
								</a>
								<a href="https://x.com/cobrasktm" class="button socials-button" target="_blank">
									<span class="icon is-small">
										<i class="fab fa-x-twitter"></i>
									</span>
								</a>
								<a href="https://www.youtube.com/@cobytm" class="button socials-button" target="_blank">
									<span class="icon is-small">
										<i class="fab fa-youtube"></i>
									</span>
								</a>
								<a href="https://github.com/SuperCoby/" class="button socials-button" target="_blank">
									<span class="icon is-small">
										<i class="fab fa-github"></i>
									</span>
								</a>
								<button
									class="button socials-button auth-icon-button"
									:class="{ 'is-logged-in': auth.state.isLoggedIn }"
									:title="auth.state.isLoggedIn ? `Log out (${auth.state.username})` : 'Login'"
									@click="auth.state.isLoggedIn ? auth.logout() : (showLogin = true)"
								>
									<span class="icon is-small">
										<i :class="auth.state.isLoggedIn ? 'fas fa-right-from-bracket' : 'fas fa-right-to-bracket'"></i>
									</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>

		<RouterView v-model="searchGame" :rarityFilter="rarityFilter" :ownFilter="ownFilter" v-if="$route.name === 'home'" />
		<RouterView v-model="searchName" v-else-if="$route.name === 'gallery'" />
		<RouterView :ownFilter="ownFilter" v-else />
		<LoginModal :show="showLogin" @close="showLogin = false" />
	</div>
</template>

<script>
import auth from '@/auth.js';
import LoginModal from '@/components/LoginModal.vue';

export default {
	components: { LoginModal },
	data() {
		return {
			auth,
			showLogin: false,
			searchGame: '',
			searchName: '',
			showFilterDropdown: false,
			rarityFilter: 'All',
			ownFilter: undefined,
		};
	},
	mounted() {
		let app = document.getElementById('app');
		app.addEventListener(
			'click',
			(e) => {
				if (!e.target.classList.contains('dropdown-item')) {
					this.showFilterDropdown = false;
				}
			},
			{
				capture: true,
			},
		);
	},
	watch: {
		$route(to, from) {
			if (to.name === from.name) return;
			this.searchGame = '';
			this.searchName = '';
			this.showFilterDropdown = false;
			this.rarityFilter = 'All';
			this.ownFilter = undefined;
		},
	},
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

#app {
	font-family: Poppins, Helvetica, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	min-height: 100vh;
}
#socials {
	gap: 0.25rem;
}
.auth-icon-button.is-logged-in {
	color: #fff !important;
	background-color: #48c78e !important;
	border-color: #48c78e !important;
}
nav {
	padding: 30px;
}

nav a {
	font-weight: bold;
	color: #2c3e50;
}

.navbar-item:hover,
.navbar-item.router-link-active {
	color: white;
	border-bottom: 2px solid white;
}
.nav-divider {
	margin-left: 10px;
	margin-right: 10px;
	color: grey;
	transform: skewX(-20deg);
}
.control.has-icons-left .input:focus ~ .icon {
	color: white;
}
.input:focus {
	border-color: white;
	box-shadow: rgba(255, 255, 255, 0.25) 0px 0px 0px 3px;
}
#search-game {
	max-width: 200px;
}

@import 'vue3-carousel/carousel.css';
.carousel {
	--vc-nav-color: #aaaaaa;
	--vc-nav-color-hover: white;
	--vc-nav-border-radius: 0;
	--vc-nav-height: 100%;
}
.carousel__next {
	background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5)) !important;
}
.carousel__prev {
	background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5)) !important;
}
.carousel__next--disabled,
.carousel__prev--disabled {
	cursor: default !important;
	opacity: 0 !important;
}
.country-flag {
	height: 50px;
	overflow: hidden;
	background-size: cover;
	background-position: center center;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 5px;
	position: relative;
	cursor: pointer;
}
.country-name {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-weight: bold;
	visibility: hidden;
}
.country-flag:hover .country-name,
.country-flag.active .country-name {
	background-color: rgba(0, 0, 0, 0.5);
	visibility: visible;
	transition: all 0.3s;
}

.fade-enter-active {
	transition: all 0.3s ease-out;
}

.fade-leave-active {
	transition: all 0.8s ease-in;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
